import React, {
    useEffect,
    useState,
    useRef,
    useMemo,
    useCallback,
} from 'react';
import '../../styles.css';
import DealModal from '../../../components/customModal/DealModal';
import SupportLink from '../../Common/SupportLink';
import DealsGridView from './DealsGridView';
import DealsListView from './DealsListView';
import { useSelector, useDispatch } from 'react-redux';
import { setCompanyUserLoading } from 'ReduxStore/Slices/companyUserSlice';
import { getDealsApi, getDealsCountApi } from 'api/SalesApi';
import { setSearchEvent } from 'ReduxStore/Slices/salesSlice';
import { getAllUsers } from 'api/UsersApi';
import { getPiplines, getStages } from 'api/SettingsApi';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from "react-bootstrap/Tooltip";
import { exportDeals } from 'api/ExportApi'

import './deals.css';
import 'bootstrap/dist/css/bootstrap.css';

function Deals(props) {
    const [dataApi, setDataApi] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [assignee, setAssignee] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [dealsView, setDealsView] = useState('list');
    const [isDealEdit, setIsDealEdit] = useState(false);
    const [pipelines, setPipelines] = useState([]);
    const [refreshDeals, setRefreshDeals] = useState(false);
    const [selectedPipeline, setSelectedPipeline] = useState(null);
    const [currentSelectedDeal, setCurrentSelectedDeal] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    const searchText = useRef('');
    const assigneeValue = useRef('');
    const pipelineValueRef = useRef('');
    const dispatch = useDispatch();
    const { companyUserLoading } = useSelector(
        (state) => state.companyUserSetter
    );

    useEffect(() => {
        dispatch(setCompanyUserLoading(true));
        getAllUsers(100, 0).then((users) => {
            setAssignee(users);
        });
        getPiplines(1000, 0).then((res) => {
            setPipelines(res);
            setSelectedPipeline(res[0].id);
            if (dealsView === 'grid') {
                pipelineValueRef.current.value = res[0].id;
            }
        });
        setIsDealEdit(false);
    }, [dealsView]);

    const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
        dispatch(setCompanyUserLoading(true));
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        setPageIndex(pageIndex);

        let sq = `limit=${pageSize}&offset=${startRow}`;
        if (dealsView === 'list') {
            if (searchText.current.value !== '') {
                sq += `&search=${searchText.current.value}`;
            }
            if (assigneeValue.current.value !== '') {
                sq += `&assigneeId=${assigneeValue.current.value}`;
            }
        }


        await getDealsCountApi(sq)
            .then((data) => {
                setPageCount(Math.ceil(data.count / pageSize));
                setTotal(data.count);
            })
            .catch((e) => { })

     getDealsApi(sq)
            .then((data) => {
                console.log("hhhllllllll", data)

                data = data.map((r) => {
                    let obj = {
                        id: r.id,
                        contacts: r.persons || [],
                        amount: '$ ' + r.amount? r.amount.value : "0",
                        name: r.name.value,
                        stage: r.stage ? r.stage.label: "",
                        assignee: r.assignee ? r.assignee.name:"",
                        closeDate: r.closeDate ? r.closeDate.value:"",
                        owner: r.createdBy.name,
                        pipeline: r.stage?.pipeline?.name || '',
                    };

                    return obj;
                });
                console.log("hhhhhhhhhhhhhh jj")

                setDataApi(data);
                dispatch(setCompanyUserLoading(false));
            })
            .catch((e) => { })
    }, [dealsView]);

    const data = useMemo(() => dataApi, [dataApi]);
    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Stage',
                accessor: 'stage',
            },
            {
                Header: 'Pipeline',
                accessor: 'pipeline',
            },
            {
                Header: 'Assignee',
                accessor: 'assignee',
            },
            {
                Header: 'Amount',
                accessor: 'amount',
            },
            {
                Header: 'Owner',
                accessor: 'owner',
            },
            {
                Header: 'Close Date',
                accessor: 'closeDate',
            },
            {
                // width: 300,
                Header: '',
                accessor: '....',
                Cell: ({ cell }) => (
                    <a
                        onClick={() =>
                            props.history.push(`/admin/sales/dealDetail`, {
                                dealId: cell.row.original.id,
                            })
                        }
                        style={{
                            color: '#2C40CE',
                            cursor: 'pointer',
                            width: '100%',
                            textAlign: 'start',
                        }}
                    >
                        Details
                    </a>
                ),
            },
        ],
        [dataApi]
    );

    const 
    handleClose = (refresh) => {
        setShowModal(false);

        if (refresh == true) {
            fetchData({
                pageSize: 50,
                pageIndex: 0,
            });
        }
    };

    const setShowDealModal = (deal) => {
        setShowModal(true);
        setIsDealEdit(true);
        setCurrentSelectedDeal(deal);
    };
    function updateRole() {
        let t = localStorage.getItem('role');
        setIsAdmin(t === 'admin');
    }
    useEffect(() => {
        updateRole()
        window.addEventListener('storage', updateRole)

    }, [])

    return (
        <div className='deals'>
            <SupportLink link='https://kapitalwise.com/user-guide/sales/' />


            <div className="top-header-cont">

            <div className='page_heading' >
                <h2>Deals</h2>
                <p className='sm d-flex align-items-center'>You have {total} Deals.</p>
                

            </div>


            <div className="joifo">



            <div
                className='searchbox'
                style={{
                    display: 'flex',
                    width: '350px',
                    paddingLeft: '20px',
                }}
            >
                <input
                    placeholder='Search'
                    className='form-control search-input mr-1'
                    // style={{ maxWidth: "33%", marginLeft: "25px" }}
                    onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                            // setSearchLoading(true);
                            dispatch(setSearchEvent('search'));
                            fetchData({
                                pageSize: 50,
                                pageIndex: 0,
                            });
                        }
                    }}
                    ref={searchText}
                ></input>

            </div>
            <div className="separator-vert"> </div>

            <button
                    type='submit'
                    name='Save'
                    style={{
                        margin_top: '2v',
                        cursor: 'pointer',
                        padding: '12px 29px',
                        margin: "4px !important",
                        fontSize:"13px !important"

                    }}
                    className='add__stage lg_btn primary ml-2'
                    onClick={() => {
                        setShowModal(true);
                        setIsDealEdit(false);
                    }}
                >
                    <i class='fa fa-plus plus' aria-hidden='true'></i>
                    Create Deal
                </button>
    
            {isAdmin && <input
                onClick={exportDeals}
                type="submit"
                name="Save"
                    
                    className="add__stage lg_btn primary"
                value="Export"
            />}


             </div>



 

        </div>

  
        

    
            <div className='mt-4 mb-2 pt-2' style={{display: "flex" , justifyContent: "space-between", padding:"0px 20px ", backgroundColor:"#eee"}}>
            
<div className='dkhuiw'> <span> FILTER BY ASSIGNEE: </span>
{dealsView == 'list' ? (
                    <select
                        onChange={(e) => {
                            dispatch(setSearchEvent('byAssignee'));
                            fetchData({
                                pageSize: 50,
                                pageIndex: 0,
                            });
                        }}

                        ref={assigneeValue}
                    >
                        <option value=''>Select Assignee</option>
                        {assignee &&
                            assignee.map((user) => {
                                return <option value={user.id}>{user.name}</option>;
                            })}
                    </select>
                ) : (
                    <select
                        onChange={(e) => {
                            setSelectedPipeline(e.target.value);
                        }}
                        ref={pipelineValueRef}
                    >
                        <option value=''>Select Pipeline</option>
                        {pipelines &&
                            pipelines.map((pipeline) => {
                                return <option value={pipeline.id}>{pipeline.name}</option>;
                            })}
                    </select>
                )}
        </div>
            
            <div className='d-flex' >
                    <div className='view__toggle' style={{  }}>
                    <OverlayTrigger
                        delay={{ hide: 50, show: 50 }}
                        placement='top'
                        key='top'
                        overlay={(props) => (
                            <Tooltip id='tooltip-top' {...props}>
                                View your deals as list
                            </Tooltip>
                        )}
                    >
                        <i
                            className='fa fa-list active'
                            id='view__toggle__list'
                            onClick={(e) => {
                                setDealsView('list');
                                document
                                    .getElementById('view__toggle__grid')
                                    .classList.remove('active');
                                e.target.classList.add('active');
                            }}
                        ></i>
                    </OverlayTrigger>
                    <OverlayTrigger
                        delay={{ hide: 50, show: 50 }}
                        placement='top'
                        key='top'
                        overlay={(props) => (
                            <Tooltip id='tooltip-top' {...props}>
                                View your deals on board
                            </Tooltip>
                        )}
                    >
                        <i
                            className='fa fa-th'
                            id='view__toggle__grid'
                            onClick={(e) => {
                                setDealsView('grid');
                                document
                                    .getElementById('view__toggle__list')
                                    .classList.remove('active');
                                e.target.classList.add('active');
                            }}
                        ></i>
                    </OverlayTrigger>
                </div>
            </div>

            </div>
  

            {dealsView === 'list' ? (
                <DealsListView
                    columns={columns}
                    data={data}
                    pageCount={pageCount}
                    fetchData={fetchData}
                    loading={companyUserLoading}
                />
            ) : (
                <DealsGridView
                    pipeline={selectedPipeline}
                    setShowDealModal={setShowDealModal}
                    refreshDeals={refreshDeals}
                />
            )}

            {showModal ? (
                <DealModal
                    handleClose={handleClose}
                    isDealEdit={isDealEdit}
                    currentSelectedDeal={currentSelectedDeal}
                    setRefreshDeals={setRefreshDeals}
                />
            ) : null}
        </div>
    );
}
export default Deals;
